import backendEndpoint from '../../api/etrBackend'
import {
  MESSAGE_TYPE,
  server,
  TRANSACTION_EDIT_FAILED,
  TRANSACTION_EDIT_FETCHING,
  TRANSACTION_EDIT_SUCCESS
} from '../../constants'
import { DocumentModel } from '../../models/document'
import { RootReducers } from '../reducers'

export const setStateEditTransactionToSuccess = (payload: any) => ({
  type: TRANSACTION_EDIT_SUCCESS,
  payload
})

const setStateEditTransactionToFetching = () => ({
  type: TRANSACTION_EDIT_FETCHING
})

const setStateEditTransactionToFailed = () => ({
  type: TRANSACTION_EDIT_FAILED
})

export const cancelTransaction = (id: number, doc: DocumentModel, navigate: any) => {
  return async (dispatch: any) => {
    await backendEndpoint.patch(`${server.TRANSACTION_URL}/${id}`, doc)
    await sendMessage(id, MESSAGE_TYPE.EMAIL)
  }
}

export const completeTransction = (id: number, doc: DocumentModel) => {
  return async (dispatch: any) => {
    await backendEndpoint.patch(`${server.TRANSACTION_URL}/${id}`, doc)
  }
}

export const confirmTransaction = (params: { reason: string; relatedDocuments: number[] }) => {
  return async (dispatch: any, getState: () => RootReducers) => {
    const date = new Date()
    const agentId = getState().loginReducer.account?.agentInfo.agentId
    const agentName = getState().loginReducer.account?.agentInfo.name
    const agentBranchCode = getState().loginReducer.account?.agentInfo.branchCode
    const agentBranchName = getState().loginReducer.account?.agentInfo.branchName
    const agentUsername = getState().loginReducer.account?.agentInfo?.userName
    const agentEmail = getState().loginReducer.account?.agentInfo?.email

    const statusDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes()
      )
    )
    const etrStatusDate = statusDate

    return backendEndpoint.post(`${server.TRANSACTION_URL}/submitDocument`, {
      agentId,
      agentName,
      agentBranchCode,
      agentBranchName,
      statusDate,
      agentUsername,
      agentEmail,
      etrStatusDate,
      ...params
    })
    //await sendMessage(id, MESSAGE_TYPE.EMAIL)
  }
}

export const updateTransaction = (id: number, doc: DocumentModel, navigate: any) => {
  return async (dispatch: any) => {
    await backendEndpoint.patch(`${server.TRANSACTION_URL}/${id}`, doc)
  }
}

export const createTransaction = (doc: DocumentModel, sendType: string) => {
  return async (dispatch: any) => {
    try {
      dispatch(setStateEditTransactionToFetching())
      const result = await backendEndpoint.post(server.TRANSACTION_URL, doc)
      await sendMessage(result.data?.id as number, sendType)
      dispatch(setStateEditTransactionToSuccess(result.data))
    } catch (error) {
      dispatch(setStateEditTransactionToFailed())
      throw error
    }
  }
}

export const sendMessage = async (docId: number, sendType: string) => {
  try {
    if (docId && docId > 0) {
      const result = await backendEndpoint.post(`${server.MESSAGE_URL}/${sendType}/${docId}`)
    }
  } catch (error) {
    console.log(error)
  }
}

export const getTransactionById = (id: number, agentId: string) => {
  return async (dispatch: any) => {
    try {
      dispatch(setStateEditTransactionToFetching())
      const result = await backendEndpoint.get(`${server.TRANSACTION_URL}/${agentId}/${id}`)
      dispatch(setStateEditTransactionToSuccess(result.data))
    } catch (error) {
      //alert(JSON.stringify(error))
      dispatch(setStateEditTransactionToFailed())
    }
  }
}
